import CLDR from "./CLDR.json";
import { Translator } from "./Translator";

export type ShortDayNames = "mon" | "tue" | "wen" | "thu" | "fri" | "sat" | "sun";

interface ICldrInfo {
  minimalDays: number;
  firstDay: ShortDayNames;
}

export function getCldrInfo(): ICldrInfo {
  const activeLocale = Translator.getInstance().getActiveLocale();
  return CLDR[activeLocale] ?? { minimalDays: 4, firstDay: `mon` };
}
